export const partnershipsTranslations = {
  en: {
    title: 'Partnerships',
    subtitle: 'We are very grateful to have been accepted into the following programs:',
    programs: {
      digitalOcean: 'Digital Ocean Hatch Program',
      googleCloud: 'Google Cloud Startup Program',
      microsoft: 'Microsoft Startup Program',
      ibbCoaching: 'IBB Coaching Bonus'
    }
  },
  de: {
    title: 'Partnerschaften',
    subtitle: 'Wir sind sehr dankbar, in die folgenden Programme aufgenommen worden zu sein:',
    programs: {
      digitalOcean: 'Digital Ocean Hatch Programm',
      googleCloud: 'Google Cloud Startup Programm',
      microsoft: 'Microsoft Startup Programm',
      ibbCoaching: 'IBB Coaching Bonus'
    }
  }
}; 